import { createFileRoute } from '@tanstack/react-router'

import { BrandCampaignLanding, brandCampaignHead, loadBrandCampaign } from '../components/BrandCampaignLanding'
import { getBrandCampaign } from '../data/brandCampaigns'

const campaign = getBrandCampaign('cd-sayyes')!

export const Route = createFileRoute('/cd-sayyes')({
  loader: () => loadBrandCampaign(campaign),
  head: () => brandCampaignHead(campaign),
  component: CdSayYesPage,
})

function CdSayYesPage() {
  return <BrandCampaignLanding data={{ ...Route.useLoaderData(), campaign }} />
}
